import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { ServiceService } from '@services/service.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { CommonPipe } from '@pipes/common.pipe';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-eaudio',
  providers: [CommonPipe],
  templateUrl: './eaudio.component.html',
  styleUrls: ['./eaudio.component.sass']
})
export class EaudioComponent implements OnInit {
  error: any = { 'name': '' };
  component = "";
  btn_process=false;
  tags: any = [];
  is_owner = false;
  params: any = [];
  comments: any = [];
  id = "";
  rate = 0;
  selected_category = "";
  application = "";
  appCreateForm: FormGroup;
  page_loading=true;
  response: any = [];
  privacy_list: any = [];
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    maxFiles: 1
  };
  constructor(private _service: ServiceService,private _categoryService: CategoryService, private _commonPipe: CommonPipe, private _viewService: ViewService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "audio";
    this.appCreateForm = this.fb.group({
      name: [],
      privacy:[],
      description: [],
      tag: []
    });

    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.id = this.params['id'];
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_loading=false;
            this.response = this._global.getVal(data, 'response', '');
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'id', ''));
             this.rate = this._global.getVal(this.response, 'rating', '');
            if(this._global.getVal(this.response, 'tag', '')){
              this.tags =this._global.getVal(this.response, 'tag', '').split(",") ;
            }
          
            let THIS = this;
            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);
               
                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      let result = Helper.getCategoryChecboxValues("categoryCheck", '');
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            //   this.loadComments();

            let f = {
              'component': this.component,
              'application': this.application
            };
            this._formdataService.common(f, 'mediaVisibility').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.privacy_list = this._global.getVal(data, 'response', '');
                }
                this.appCreateForm.get('privacy').setValue(this.response.privacy);
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });
    //this.is_owner=this._global.isOwner(this._global.getVal(this.response, 'id', ''));
  }
  @ViewChild('image') public pimage: ElementRef;
  ngOnInit() {
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this.id);
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    this.pimage.nativeElement.src = this._commonPipe.transform(this.response, ['image', this.application, 'id', 'name', 'l']);
  }
  update() {
   let tag=[];
    let p = this._global.generateParams(this.appCreateForm.value, ['tag']);
    this.error = { 'name': '' };
      this.btn_process = true;
    p['component'] = this.component;
    p['application'] = this.application;
    p = this._global.paramsRemoveNull(p);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    p['status']=this._global.getVal(this.response, 'status', '');
    p['id']=this._global.getVal(this.response, 'id', '');

    if((this.tags).length>0){
      Object.entries(this.tags).forEach(([key, value]) => {
       tag.push(value);

      });
    }
    this._saveService.appUpdate(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          let pa={
            'component': this.component,
            'application': this.application,
            'entityId': this.id,
            "action": "tag",
            "entityType": this.application,
            "actionDetails": tag.join(",")
          };
          this._service.appTag(pa).subscribe(
            data => {

            },
            error => {
              console.log("error", JSON.stringify(error));
            });
          this._global.showMessage({ type: severity, message: message });

          this.router.navigate(['/my/' + this.application]);
        } else {
           this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

}
